import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  fetchTop,
  selectId,
  selectLoading,
} from "./topSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  encryptData,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
  decryptData,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { is } from "date-fns/locale";

export const TopCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectId);
  const { id } = useParams();

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [days, setDays] = useState("");
  const [isCash, setIsCash] = useState("");
  const [cashDiscount, setCashDiscount] = useState("");
  const [refTop, setRefTop] = useState("");

  const paramsId = {
    top_id: id,
  };
  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchTop({ ...paramsMasterAll }));

      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setCode(dataId.top_code);
      setName(dataId?.top_name);
      setDays(dataId?.due_date_days);
      setIsCash(dataId?.is_cash_discount);
      setCashDiscount(dataId?.cash_discount);
      setRefTop(dataId?.ref_top_id);
    }
  }, [dataId]);

  const handleSave = async () => {
    const fields = [
      { value: code, message: "input Code", valid: true },
      { value: name, message: "input Name", valid: true },
      { value: days, message: "input Days", valid: true },
      { value: isCash, message: "input Is Cash", valid: true },
      { value: cashDiscount, message: "input Cash Discount", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }
    const params = {
      top_id: id,
      top_name: name,
      top_code: code,
      due_date_days: days,
      is_cash_discount: isCash,
      cash_discount: cashDiscount,
      ref_top_id: refTop,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Top" : "Edit Top"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Top Code <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setCode(e.target.value)}
                      value={code}
                      disabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      {" "}
                      Top Name <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="days">
                  <Form.Label column sm={3}>
                    <b>
                      Days <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="number"
                      min="0"
                      onChange={(e) => {
                        const value = e.target.value;
                        setDays(value < 0 ? 0 : value); // Jika input minus, set ke 0
                      }}
                      value={days}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Is Cash <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      options={[
                        { value: true, label: "Yes" },
                        { value: false, label: "No" },
                      ]}
                      value={[
                        { value: true, label: "Yes" },
                        { value: false, label: "No" },
                      ].find((opt) => opt.value === isCash)}
                      onChange={(selected) => setIsCash(selected.value)}
                      placeholder="Select option"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      {" "}
                      Cash Discount <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="number"
                      min="0"
                      onChange={(e) => {
                        const value = e.target.value;
                        setCashDiscount(value < 0 ? 0 : value); // Jika input minus, set ke 0
                      }}
                      value={cashDiscount}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b> Ref Top</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setRefTop(e.target.value)}
                      value={refTop}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};
